import { SaleState } from "@/apps/merchant3/store/sale/mutations";

const getters = {
  saleState: (state: SaleState): SaleState => state,
};

export default getters;
